import { BaseBusinessService } from "./base-business-service.ts"
import { ChargingRulesServiceInterface } from "interfaces/charging-rules-service.ts"

export class BusinessChargingRulesService
    extends BaseBusinessService
    implements ChargingRulesServiceInterface
{
    useGetListChargingRules = () => {
        return this.get({ endpoint: '' })
    }
    useUpdateChargingRule = () => {
        return this.post({ endpoint: '' })
    }
}
